import React from "react";
import {withNamespaces} from "react-i18next";
import {Button, Spinner} from "react-bootstrap";
import HilightTable from "../../../../../components/HilightTable";
import {Link} from "react-router-dom";
import {modalActions} from "../../../../../actions/modal.actions";
import {connect} from "react-redux";
import {daliEsSystemActions} from "../../../../../actions/dali-es-system.actions";
import DaliEsSystemAreaForm from "../_forms/DaliEsSystemAreaForm";

const DaliEsSystemAreaTable = ({t, list, groups, device, showModal, removeEsSystemArea, editEsSystemArea}) => {

    const openModalRemoveArea = (row) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${row.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: row.id,
            confirmAction: () => {
                removeEsSystemArea(row.id, row.networkDeviceId);
            },
        }, 'confirm');
    };

    const openModalEditArea = (row) => {
        showModal({
            open: true,
            title: t('edit_dali-area'),
            component: <DaliEsSystemAreaForm data={row} deviceId={row.networkDeviceId} deviceGroups={groups} submitForm={(model) => editEsSystemArea(model)} />,
        }, 'formModal');
    };

    const columns = [
        {
            Header: 'label',
            accessor: 'label'
        },
        {
            Header: 'single-device-group',
            Cell: (props) => {
                const row = props.row.original;
                const group = groups?.find((x) => x.id === row.deviceGroupId);
                return (
                    <React.Fragment>
                        <b>{group?.label}</b>
                    </React.Fragment>
                )
            }
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const row = props.row.original;
                return (
                    <React.Fragment>
                        <Link to={`/panel/network-device/dali/es-system/${device?.id}/groups/${row.id}`}>
                            <Button
                                className="mx-1"
                                variant={"info"}
                            >
                                <i className="fas fa-object-group" /> &nbsp;
                                {t('groups')}
                            </Button>
                        </Link>

                        <Button className="mx-1" variant={"primary"} onClick={() => openModalEditArea(row)}>
                            <i className="fas fa-edit" />
                        </Button>

                        <Button className="mx-1" variant={"danger"} onClick={() => openModalRemoveArea(row)}>
                            <i className="fas fa-trash" />
                        </Button>
                    </React.Fragment>
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('dali-area-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({modalProps, modalType}))
    },
    editEsSystemArea: (areaModel) => {
        dispatch(daliEsSystemActions.editEsSystemArea(areaModel));
    },
    removeEsSystemArea: (areaId, deviceId) => {
        dispatch(daliEsSystemActions.deleteEsSystemArea(areaId, deviceId));
    }
});

export default withNamespaces()(connect(null, mapDispatchToProps)(DaliEsSystemAreaTable));
